<template>
  <div class="card card-flush shadow-sm">
    <div class="card-header">
      <h3 class="card-title fw-bold">Balanță de Verificare</h3>
      <div class="card-toolbar">
         <button type="button" class="btn btn-sm btn-light-info fw-bold me-2" @click="showImportModal">
           <i class="fa-solid fa-upload me-1"></i> Importă balanță inițială
         </button>
          <button type="button" class="btn btn-sm btn-light-success fw-bold me-2" @click="exportXLS" v-if="balantaData">
            <i class="fa-solid fa-file-excel me-1"></i> Excel
          </button>
          <button type="button" class="btn btn-sm btn-light-danger fw-bold me-2" @click="exportPDF" v-if="balantaData">
            <i class="fa-solid fa-file-pdf me-1"></i> PDF
          </button>
          <button type="button" class="btn btn-sm" :class="showFilters ? 'btn-light-primary' : 'btn-primary'" @click="showFilters = !showFilters">
            <i class="fa-solid" :class="showFilters ? 'fa-chevron-up' : 'fa-filter'"></i>
            {{ showFilters ? 'Ascunde Filtre' : 'Arată Filtre' }}
          </button>
       </div>
    </div>
    <div class="card-body">
      <!-- Filtre SAGA Style -->
      <div v-if="!showFilters && balantaData" class="mb-4 bg-light-primary p-3 rounded d-flex align-items-center justify-content-between border border-primary border-dashed">
          <div class="d-flex align-items-center">
            <i class="fa-solid fa-info-circle text-primary me-3 fs-3"></i>
            <div>
              <span class="fw-bold">Balanță generată pentru perioada:</span> 
              <span class="badge badge-primary ms-2">{{ filters.from }} — {{ filters.to }}</span>
              <span class="ms-4 text-gray-600 fs-8">Filtrele sunt active, dar minimizate.</span>
            </div>
          </div>
          <button class="btn btn-link btn-sm fw-bold p-0" @click="showFilters = true">Modifică opțiuni</button>
      </div>

      <div class="mb-8 p-6 bg-light rounded border border-gray-300" v-show="showFilters">
        <form @submit.prevent="loadData">
          <div class="row">
            <!-- Left Side: Checkboxes -->
            <div class="col-md-6 border-end border-gray-300">
                <div class="d-flex flex-column gap-2 mb-4">
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" v-model="uiCols.col_sia" />
                    <span class="form-check-label fw-bold text-gray-800">Solduri inițiale an</span>
                  </label>
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" v-model="uiCols.col_sip" />
                    <span class="form-check-label fw-bold text-gray-800">Solduri inițiale perioada</span>
                  </label>
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" v-model="uiCols.col_sp" />
                    <span class="form-check-label fw-bold text-gray-800">Sume precedente</span>
                  </label>
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" v-model="uiCols.col_rp" />
                    <span class="form-check-label fw-bold text-gray-800">Rulaje perioada</span>
                  </label>
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" v-model="uiCols.col_trp" />
                    <span class="form-check-label fw-bold text-gray-800">Total rulaje (de la începutul anului)</span>
                  </label>
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" v-model="uiCols.col_st" />
                    <span class="form-check-label fw-bold text-gray-800">Sume totale</span>
                  </label>
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" v-model="uiCols.col_sf" />
                    <span class="form-check-label fw-bold text-gray-800">Solduri finale</span>
                  </label>
                </div>

                <!-- Analitica -->
                <div class="mt-4 pt-4 border-top border-gray-300">
                  <label class="form-check form-check-custom form-check-sm mb-3">
                    <input class="form-check-input" type="checkbox" v-model="filters.analitica" />
                    <span class="form-check-label fw-bold text-gray-800">Analitică</span>
                  </label>

                  <div class="ps-6" v-if="filters.analitica">
                    <div class="d-flex align-items-center gap-4 mb-2">
                        <label class="form-check form-check-custom form-check-sm form-radio">
                          <input class="form-check-input" type="radio" value="cum" v-model="filters.analitica_mode" />
                          <span class="form-check-label text-gray-800"><u>C</u>u</span>
                        </label>
                        <label class="form-check form-check-custom form-check-sm form-radio">
                          <input class="form-check-input" type="radio" value="fara" v-model="filters.analitica_mode" />
                          <span class="form-check-label text-gray-800">Fara</span>
                        </label>
                        <span class="fw-semibold text-gray-700">analitice pentru conturile:</span>
                    </div>
                    
                    <!-- 8 Inputs for exceptions -->
                    <div class="ps-2">
                      <div class="row g-2" style="max-width: 400px;">
                        <div class="col-3" v-for="i in 8" :key="'exc'+i">
                          <input type="text" class="form-control form-control-sm px-2 text-center" 
                                 v-model="filters.exceptii[i-1]" placeholder="..." maxlength="10" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Alte optiuni inferioare -->
                <div class="mt-4 pt-4 border-top border-gray-300 d-flex flex-column gap-2">
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" v-model="filters.hideZero" />
                    <span class="form-check-label fw-bold text-gray-800">Ascunde conturile cu sold și rulaj zero</span>
                  </label>
                  <label class="form-check form-check-custom form-check-sm mt-2">
                    <input class="form-check-input" type="checkbox" disabled />
                    <span class="form-check-label text-gray-500">Sumare ct. sintetice de grad II la ct. sintetice de grad I (în curând)</span>
                  </label>
                  <label class="form-check form-check-custom form-check-sm">
                    <input class="form-check-input" type="checkbox" disabled />
                    <span class="form-check-label text-gray-500">Inclusiv conturi din afara bilantului</span>
                  </label>
                  
                  <div class="mt-2" style="max-width: 150px;">
                     <select class="form-select form-select-sm" disabled>
                        <option>Lei</option>
                     </select>
                  </div>
                </div>
            </div>

            <!-- Right Side: Dates & Buttons -->
            <div class="col-md-6 d-flex flex-column">
                <div class="d-flex justify-content-between align-items-start ps-md-6">
                    <!-- Date Inputs -->
                    <div class="d-flex flex-column gap-3">
                        <div class="d-flex align-items-center gap-2">
                           <div class="input-group input-group-sm" style="width: 150px;">
                              <input type="text" ref="dateFrom" class="form-control" v-model="filters.from" placeholder="De la" />
                              <span class="input-group-text cursor-pointer" @click="openPicker('from')">
                                 <i class="fa-solid fa-calendar-days fs-7"></i>
                              </span>
                           </div>
                           <span class="text-gray-500">—</span>
                           <div class="input-group input-group-sm" style="width: 150px;">
                              <input type="text" ref="dateTo" class="form-control" v-model="filters.to" placeholder="Până la" />
                              <span class="input-group-text cursor-pointer" @click="openPicker('to')">
                                 <i class="fa-solid fa-calendar-days fs-7"></i>
                              </span>
                           </div>
                        </div>
                        <div class="d-flex align-items-center gap-2 mt-2">
                           <div class="d-flex flex-column gap-0 me-1">
                              <button type="button" class="btn btn-xs btn-icon btn-light-primary h-20px w-20px mb-1" @click="prevMonth" title="Luna anterioară">
                                <i class="fa-solid fa-chevron-up fs-9"></i>
                              </button>
                              <button type="button" class="btn btn-xs btn-icon btn-light-primary h-20px w-20px" @click="nextMonth" title="Luna următoare">
                                <i class="fa-solid fa-chevron-down fs-9"></i>
                              </button>
                           </div>
                           <select class="form-select form-select-sm" v-model="selected_month" style="width: 110px;">
                              <option v-for="(name, m) in monthNames" :key="m" :value="m+1">{{ name }}</option>
                           </select>
                           <input type="number" class="form-control form-control-sm" v-model="selected_year" style="width: 70px;" />
                        </div>
                    </div>
                    
                    <!-- Action Buttons -->
                    <div class="d-flex flex-column gap-2">
                        <button type="submit" class="btn btn-primary px-8" :disabled="loading">
                           <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                           <u>A</u>ccept
                        </button>
                        <button type="button" class="btn btn-light px-8" @click="resetFilters">
                           <u>R</u>enunț
                        </button>
                    </div>
                </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Tabel Balanta -->
      <div v-if="loading" class="py-20 text-center">
         <div class="spinner-border text-primary w-50px h-50px" role="status"></div>
         <div class="text-muted mt-4 fs-5">Se generează balanța din Registrul Jurnal...</div>
      </div>

      <div v-else-if="!balantaData" class="py-20 text-center text-muted">
         <i class="fa-solid fa-scale-unbalanced-flip fs-3x mb-5 opacity-20"></i>
         <p class="fs-4">Selectează perioada și apasă butonul "Accept" pentru a genera balanța.</p>
      </div>

      <div v-else class="balanta-container">
        <div class="table-responsive">
          <table class="table table-bordered table-hover align-middle gs-4 gy-2 border-gray-300">
            <thead class="bg-light fw-bold text-gray-800 fs-7 text-uppercase text-center">
              <tr>
                <th rowspan="2" class="align-middle min-w-80px">Cont</th>
                <th rowspan="2" class="align-middle min-w-200px">Denumirea contului</th>
                
                <th colspan="2" class="border-bottom" v-if="uiCols.col_sia">Solduri inițiale an</th>
                <th colspan="2" class="border-bottom" v-if="uiCols.col_sip">Solduri inițiale perioada</th>
                <th colspan="2" class="border-bottom" v-if="uiCols.col_sp">Sume precedente</th>
                <th colspan="2" class="border-bottom" v-if="uiCols.col_rp">Rulaje perioada</th>
                <th colspan="2" class="border-bottom" v-if="uiCols.col_trp">Total rulaje an</th>
                <th colspan="2" class="border-bottom" v-if="uiCols.col_st">Sume totale</th>
                <th colspan="2" class="border-bottom" v-if="uiCols.col_sf">Solduri finale</th>
              </tr>
              <tr>
                <template v-if="uiCols.col_sia">
                    <th class="min-w-100px border-start">Debitoare</th><th class="min-w-100px">Creditoare</th>
                </template>
                <template v-if="uiCols.col_sip">
                    <th class="min-w-100px border-start">Debitoare</th><th class="min-w-100px">Creditoare</th>
                </template>
                <template v-if="uiCols.col_sp">
                    <th class="min-w-100px border-start">Debitoare</th><th class="min-w-100px">Creditoare</th>
                </template>
                <template v-if="uiCols.col_rp">
                    <th class="min-w-100px border-start">Debitoare</th><th class="min-w-100px">Creditoare</th>
                </template>
                <template v-if="uiCols.col_trp">
                    <th class="min-w-100px border-start">Debitoare</th><th class="min-w-100px">Creditoare</th>
                </template>
                <template v-if="uiCols.col_st">
                    <th class="min-w-100px border-start">Debitoare</th><th class="min-w-100px">Creditoare</th>
                </template>
                <template v-if="uiCols.col_sf">
                    <th class="min-w-100px border-start">Debitoare</th><th class="min-w-100px">Creditoare</th>
                </template>
              </tr>
            </thead>
            <tbody class="fs-7">
              <template v-for="(clasaData, clasaIdx) in balantaData.statistici.clase" :key="'cl_'+clasaIdx">
                 <!-- Randurile de conturi din aceasta clasa -->
                 <tr v-for="cont in filteredConturiClasa(clasaIdx)" :key="cont.id" 
                     :class="{'fw-bold bg-light-soft': cont.parent_id === null, 'ps-5': cont.parent_id !== null}">
                   <td class="fw-bold">{{ cont.cod }}</td>
                   <td><span :class="{'ps-4': cont.parent_id !== null}">{{ cont.descriere }}</span></td>
                   
                   <template v-if="uiCols.col_sia">
                       <td class="text-end">{{ formatVal(cont.sold_init_an_d) }}</td><td class="text-end">{{ formatVal(cont.sold_init_an_c) }}</td>
                   </template>
                   <template v-if="uiCols.col_sip">
                       <td class="text-end">{{ formatVal(cont.sold_init_per_d) }}</td><td class="text-end">{{ formatVal(cont.sold_init_per_c) }}</td>
                   </template>
                   <template v-if="uiCols.col_sp">
                       <td class="text-end">{{ formatVal(cont.rulaj_prec_d) }}</td><td class="text-end">{{ formatVal(cont.rulaj_prec_c) }}</td>
                   </template>
                   <template v-if="uiCols.col_rp">
                       <td class="text-end text-primary">{{ formatVal(cont.rulaj_per_d) }}</td><td class="text-end text-primary">{{ formatVal(cont.rulaj_per_c) }}</td>
                   </template>
                   <template v-if="uiCols.col_trp">
                       <td class="text-end">{{ formatVal(cont.total_rulaje_d) }}</td><td class="text-end">{{ formatVal(cont.total_rulaje_c) }}</td>
                   </template>
                   <template v-if="uiCols.col_st">
                       <td class="text-end fw-semibold">{{ formatVal(cont.total_sume_d) }}</td><td class="text-end fw-semibold">{{ formatVal(cont.total_sume_c) }}</td>
                   </template>
                   <template v-if="uiCols.col_sf">
                       <td class="text-end" :class="{'text-success fw-bold': cont.sold_fin_d > 0}">{{ formatVal(cont.sold_fin_d) }}</td><td class="text-end" :class="{'text-danger fw-bold': cont.sold_fin_c > 0}">{{ formatVal(cont.sold_fin_c) }}</td>
                   </template>
                 </tr>

                 <!-- Total Clasa -->
                 <tr class="bg-light-primary fw-bolder text-primary">
                    <td colspan="2" class="text-uppercase">{{ clasaData.nume }}</td>
                    
                    <template v-if="uiCols.col_sia">
                        <td class="text-end">{{ formatVal(clasaData.sold_init_an_d) }}</td><td class="text-end">{{ formatVal(clasaData.sold_init_an_c) }}</td>
                    </template>
                    <template v-if="uiCols.col_sip">
                        <td class="text-end">{{ formatVal(clasaData.sold_init_per_d) }}</td><td class="text-end">{{ formatVal(clasaData.sold_init_per_c) }}</td>
                    </template>
                    <template v-if="uiCols.col_sp">
                        <td class="text-end">{{ formatVal(clasaData.rulaj_prec_d) }}</td><td class="text-end">{{ formatVal(clasaData.rulaj_prec_c) }}</td>
                    </template>
                    <template v-if="uiCols.col_rp">
                        <td class="text-end">{{ formatVal(clasaData.rulaj_per_d) }}</td><td class="text-end">{{ formatVal(clasaData.rulaj_per_c) }}</td>
                    </template>
                    <template v-if="uiCols.col_trp">
                        <td class="text-end">{{ formatVal(clasaData.total_rulaje_d) }}</td><td class="text-end">{{ formatVal(clasaData.total_rulaje_c) }}</td>
                    </template>
                    <template v-if="uiCols.col_st">
                        <td class="text-end">{{ formatVal(clasaData.total_sume_d) }}</td><td class="text-end">{{ formatVal(clasaData.total_sume_c) }}</td>
                    </template>
                    <template v-if="uiCols.col_sf">
                        <td class="text-end">{{ formatVal(clasaData.sold_fin_d) }}</td><td class="text-end">{{ formatVal(clasaData.sold_fin_c) }}</td>
                    </template>
                 </tr>
              </template>
            </tbody>
            
            <!-- Total General -->
            <tfoot class="bg-gray-200 text-gray-900 fw-bold fs-6 border-top border-2 border-gray-400">
              <tr>
                <td colspan="2">TOTAL GENERAL</td>
                <template v-if="uiCols.col_sia">
                    <td class="text-end">{{ formatVal(balantaData.statistici.total_general.sold_init_an_d) }}</td><td class="text-end">{{ formatVal(balantaData.statistici.total_general.sold_init_an_c) }}</td>
                </template>
                <template v-if="uiCols.col_sip">
                    <td class="text-end">{{ formatVal(balantaData.statistici.total_general.sold_init_per_d) }}</td><td class="text-end">{{ formatVal(balantaData.statistici.total_general.sold_init_per_c) }}</td>
                </template>
                <template v-if="uiCols.col_sp">
                    <td class="text-end">{{ formatVal(balantaData.statistici.total_general.rulaj_prec_d) }}</td><td class="text-end">{{ formatVal(balantaData.statistici.total_general.rulaj_prec_c) }}</td>
                </template>
                <template v-if="uiCols.col_rp">
                    <td class="text-end">{{ formatVal(balantaData.statistici.total_general.rulaj_per_d) }}</td><td class="text-end">{{ formatVal(balantaData.statistici.total_general.rulaj_per_c) }}</td>
                </template>
                <template v-if="uiCols.col_trp">
                    <td class="text-end">{{ formatVal(balantaData.statistici.total_general.total_rulaje_d) }}</td><td class="text-end">{{ formatVal(balantaData.statistici.total_general.total_rulaje_c) }}</td>
                </template>
                <template v-if="uiCols.col_st">
                    <td class="text-end">{{ formatVal(balantaData.statistici.total_general.total_sume_d) }}</td><td class="text-end">{{ formatVal(balantaData.statistici.total_general.total_sume_c) }}</td>
                </template>
                <template v-if="uiCols.col_sf">
                    <td class="text-end">{{ formatVal(balantaData.statistici.total_general.sold_fin_d) }}</td><td class="text-end">{{ formatVal(balantaData.statistici.total_general.sold_fin_c) }}</td>
                </template>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal Import -->
    <ModalImportBalanta ref="importModal" :firma-id="firmaId" @imported="loadData" />
  </div>
</template>

<script>
import ModalImportBalanta from './ModalImportBalanta.vue';
import Swal from 'sweetalert2';
import flatpickr from "flatpickr";
import { Romanian } from "flatpickr/dist/l10n/ro.js";
import "flatpickr/dist/flatpickr.min.css";

export default {
  name: 'BalantaContabila',
  components: { ModalImportBalanta },
  props: {
    firmaId: {
      type: Number,
      required: true
    }
  },
  data() {
    const today = new Date();
    return {
      loading: false,
      balantaData: null,
      showFilters: true,
      
      // Control randare coloane (SAGA defaults)
      uiCols: {
        col_sia: false,
        col_sip: false,
        col_sp: true,
        col_rp: true,
        col_trp: false,
        col_st: true,
        col_sf: true,
      },

      filters: {
        from: '',
        to: '',
        analitica: false,
        analitica_mode: 'cum', // 'cum' or 'fara'
        exceptii: ['', '', '', '', '', '', '', ''],
        hideZero: true
      },

      selected_month: today.getMonth() + 1,
      selected_year: today.getFullYear(),
      fpFrom: null,
      fpTo: null,
      monthNames: [
        'Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie',
        'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'
      ]
    }
  },
  mounted() {
    this.initPickers();
    this.autoSetDates();
  },
  methods: {
    initPickers() {
      const config = {
        locale: Romanian,
        dateFormat: "Y-m-d",
        allowInput: true,
      };
      this.fpFrom = flatpickr(this.$refs.dateFrom, {
        ...config,
        onChange: (selectedDates, dateStr) => {
          this.filters.from = dateStr;
        }
      });
      this.fpTo = flatpickr(this.$refs.dateTo, {
        ...config,
        onChange: (selectedDates, dateStr) => {
          this.filters.to = dateStr;
        }
      });
    },
    openPicker(type) {
      if (type === 'from' && this.fpFrom) this.fpFrom.open();
      if (type === 'to' && this.fpTo) this.fpTo.open();
    },
    autoSetDates() {
      const y = this.selected_year;
      const m = this.selected_month;
      const firstDay = `${y}-${String(m).padStart(2, '0')}-01`;
      const lastDayDate = new Date(y, m, 0);
      const lastDay = `${y}-${String(m).padStart(2, '0')}-${String(lastDayDate.getDate()).padStart(2, '0')}`;
      
      this.filters.from = firstDay;
      this.filters.to = lastDay;
    },
    prevMonth() {
      if (this.selected_month === 1) {
        this.selected_month = 12;
        this.selected_year--;
      } else {
        this.selected_month--;
      }
    },
    nextMonth() {
      if (this.selected_month === 12) {
        this.selected_month = 1;
        this.selected_year++;
      } else {
        this.selected_month++;
      }
    },
    resetFilters() {
      // Optiuni default SAGA
      this.uiCols = {
        col_sia: false, col_sip: false, col_sp: true, col_rp: true, 
        col_trp: false, col_st: true, col_sf: true
      };
      this.filters.analitica = false;
      this.filters.exceptii = ['', '', '', '', '', '', '', ''];
      
      const today = new Date();
      this.selected_month = today.getMonth() + 1;
      this.selected_year = today.getFullYear();
      this.autoSetDates();
    },
    async loadData() {
      this.loading = true;
      
      // Construim payload-ul pentru logica backend (analitica_mode = all/none/cu_exceptii/fara_exceptii)
      let aMode = 'none';
      let cleanExceptii = this.filters.exceptii.filter(e => e.trim() !== '');

      if (this.filters.analitica) {
          if (cleanExceptii.length === 0) {
              aMode = 'all'; // daca e bifat dar casutele sunt goale, afiseaza tot.
          } else {
              aMode = this.filters.analitica_mode === 'cum' ? 'cu_exceptii' : 'fara_exceptii';
          }
      }

      try {
        const res = await axios.post('/api/contabilitate/balanta/generate', {
          id_firma: this.firmaId,
          from: this.filters.from,
          to: this.filters.to,
          options: {
             analitica_mode: aMode,
             conturi_exceptii: cleanExceptii,
             hide_zero: this.filters.hideZero
          }
        });
        this.balantaData = res.data;
        this.showFilters = false; // Minimizăm automat filtrele la succes
      } catch (e) {
        console.error("Eroare la generarea balantei", e);
        const msg = e.response?.data?.message || e.message;
        Swal.fire({
          icon: 'error',
          title: 'Eroare',
          text: msg
        });
      } finally {
        this.loading = false;
      }
    },
    formatVal(val) {
      if (!val || val === 0) return '-';
      return Number(val).toLocaleString('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    filteredConturiClasa(clasaIdx) {
      if (!this.balantaData || !this.balantaData.date) return [];
      return this.balantaData.date.filter(c => c.cod.startsWith(clasaIdx));
    },
    showImportModal() {
      if (this.$refs.importModal) {
        this.$refs.importModal.showModal();
      }
    },
    async exportXLS() {
      try {
        Swal.fire({
          title: 'Se generează fișierul...',
          text: 'Vă rugăm așteptați.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Calculăm modul analitic ca în loadData
        let aMode = 'none';
        let cleanExceptii = this.filters.exceptii.filter(e => e.trim() !== '');
        if (this.filters.analitica) {
            if (cleanExceptii.length === 0) aMode = 'all';
            else aMode = this.filters.analitica_mode === 'cum' ? 'cu_exceptii' : 'fara_exceptii';
        }

        const response = await axios.post('/api/contabilitate/balanta/export-excel', {
          id_firma: this.firmaId,
          from: this.filters.from,
          to: this.filters.to,
          uiCols: this.uiCols,
          options: {
             analitica_mode: aMode,
             conturi_exceptii: cleanExceptii,
             hide_zero: this.filters.hideZero
          }
        }, { responseType: 'blob' });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const fileName = `Balanta_Verificare_${this.filters.from}_${this.filters.to}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        
        Swal.close();
      } catch (e) {
        console.error("Eroare la export Excel", e);
        Swal.fire('Eroare', 'Nu s-a putut genera fișierul Excel.', 'error');
      }
    },
    async exportPDF() {
      try {
        Swal.fire({
          title: 'Se generează PDF-ul...',
          text: 'Vă rugăm așteptați.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        let aMode = 'none';
        let cleanExceptii = this.filters.exceptii.filter(e => e.trim() !== '');
        if (this.filters.analitica) {
            if (cleanExceptii.length === 0) aMode = 'all';
            else aMode = this.filters.analitica_mode === 'cum' ? 'cu_exceptii' : 'fara_exceptii';
        }

        const response = await axios.post('/api/contabilitate/balanta/export-pdf', {
          id_firma: this.firmaId,
          from: this.filters.from,
          to: this.filters.to,
          uiCols: this.uiCols,
          options: {
             analitica_mode: aMode,
             conturi_exceptii: cleanExceptii,
             hide_zero: this.filters.hideZero
          }
        }, { responseType: 'blob' });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const fileName = `Balanta_Verificare_${this.filters.from}_${this.filters.to}.pdf`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        
        Swal.close();
      } catch (e) {
        console.error("Eroare la export PDF", e);
        Swal.fire('Eroare', 'Nu s-a putut genera fișierul PDF.', 'error');
      }
    }
  },
  watch: {
    firmaId() {
       this.balantaData = null;
    },
    selected_month() {
      this.autoSetDates();
    },
    selected_year() {
      this.autoSetDates();
    },
    'filters.from'(newVal) {
      if (!newVal) return;
      const d = new Date(newVal);
      if (!isNaN(d.getTime())) {
        // Dacă este prima zi din lună, sincronizăm dropdown-ul
        if (d.getDate() === 1) {
          const m = d.getMonth() + 1;
          const y = d.getFullYear();
          if (this.selected_month !== m) this.selected_month = m;
          if (this.selected_year !== y) this.selected_year = y;
        }
      }
      if (this.fpFrom && newVal !== this.fpFrom.input.value) {
        this.fpFrom.setDate(newVal, false);
      }
    },
    'filters.to'(newVal) {
      if (this.fpTo && newVal !== this.fpTo.input.value) {
        this.fpTo.setDate(newVal, false);
      }
    }
  }
}
</script>

<style scoped>
.balanta-container {
  margin-top: 1rem;
}
.ps-4 { padding-left: 1.5rem !important; }
.ps-5 { padding-left: 2.5rem !important; }

.bg-light-soft {
  background-color: #fcfcfd;
}

table thead th {
  vertical-align: middle;
  background-color: #f8f9fa;
  border-bottom-width: 2px;
}

table tfoot td {
  border-top: 2px solid #222 !important;
}

@media print {
  .card-header, .bg-light, form {
    display: none !important;
  }
  .card { border: none !important; }
  .table-responsive { overflow: visible !important; }
}
</style>
